import React from 'react';
import {SelectInput} from '~/components/Controls/Select';
import {useAbility} from '~/lib/ability';
import {useResource} from '~/lib/loader';
import {fetchSellerPreviews} from '~/modules/Clients/api';
import {useSession} from '~/modules/Profile/session';
import {RootAbility} from '~/root_ability';
import style from './index.module.scss';

export const SellerSwitcher = () => {
    const ability = useAbility(RootAbility);
    const {session, setSelectedSeller} = useSession();
    const {resource: sellers, isPending} = useResource(() => fetchSellerPreviews(), []);

    if (!ability.isSeller() && !ability.isSelfServe()) return null;

    const items = sellers.map(s => ({label: s.name ?? String(s.id), value: s.id}));
    if (isPending || items.length <= 1) return null;

    return (
        <SelectInput
            value={session.selectedSellerId}
            items={items}
            disabled={isPending}
            onChange={(id) => setSelectedSeller?.(id)}
            className={style.agencySwitcher}
            searchable
        />
    );
};
